export function asset(path, prefix = '/assets') {
  if (/^https?:\/\//.test(path)) return path
  return (process.env.PUBLIC_URL || '') + prefix + path
}